<div id="tf-login" fxLayout="column">
    <div class="custom-top-nav py-2">
        <img class="page-giant-logo border-1 mx-3" width="140" src="../../../../assets/images/logo/giant2.png">
    </div>
    <div class="company-info py-2 text-center">
        <h5 class="m-0">Account Authentication Process</h5>
    </div>
    <div id="tf-login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <div id="tf-login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
            <!-- <div class="logo">
                <img src="../../../../assets/images/logo/giant2.png">
            </div> -->

            <!-- <div class="title">Account Authentication Process</div> -->
            <p>Select your preferred verification code delivery method</p>
            <form name="tfLoginForm" #tftLoginForm="ngForm">

                <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
                    [(ngModel)]="userModel.Type" #type="ngModel" name="type">
                    <mat-radio-button style="margin-left: 40px" class="radioButtonFont" value="SMS">SMS
                    </mat-radio-button>
                    <mat-radio-button style="margin-left: 30px" class="radioButtonFont" value="Email">Email
                    </mat-radio-button>
                </mat-radio-group>
                <br />
                <br />
                <!-- <input formControlName="firstname" type="text" class="form-control input-sm"> -->
                <mat-label>Codes will be sent to the following:</mat-label>
                <br />
                <br />
                <mat-form-field>
                    <mat-label style="font-weight: bold;">Email:</mat-label>

                    <input matInput type="text" readonly style="font-weight: bold;" [(ngModel)]="userModel.Email"
                        #email="ngModel" name="email">
                </mat-form-field>
                <mat-form-field>
                    <mat-label style="font-weight: bold;">Mobile Phone:</mat-label>
                    <input matInput type="text" readonly style="font-weight: bold;" [(ngModel)]="userModel.PhoneNo"
                        #phoneNo="ngModel" name="phoneNo">
                </mat-form-field>
                <br />
                <div style="margin-left: 10px">Full details are not shown for security purposes.</div>
                <button mat-raised-button style="background-color: #36639f; color: #fff;; cursor: pointer; width: 100%; margin-bottom: 5px;"
                    class="submit-button" aria-label="Submit" (click)="SendAuthenticationCode()">
                    Submit
                </button>
                <div id="codev">
                </div>
            </form>
        </div>
    </div>
</div>